import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

 const StyledBox = styled(Box)(({ theme }) => ({
 backgroundColor: theme.palette.background.secondary,
 padding :theme.spacing(8, 0),
 '& .WJSItem':{
  display: 'flex',
  gap: theme.spacing(2),
  flexDirection: 'column',
  
 },
 '& .WJSIcon':{
  marginBottom: theme.spacing(1),
  fontSize: theme.spacing(4.5)
 },
 '& .WJSDesc':{
    color: theme.palette.text.secondary,
 },
}));
export default StyledBox;
